import React from 'react';
import { IconProps } from './types';

export const FileIcon = ({ className, title }: IconProps) => (
  <svg
    id="Laag_2"
    data-name="Laag 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    className={className}
  >
    <title>{title}</title>
    <path d="M16,1H5V29H25V10Zm0,2.83L22.17,10H16ZM7,27V3h7v9h9V27Z" />
  </svg>
);
